import { api } from './client';

/**
 * LAS MASTERCLASS DE ENRIQUE. Prefijo `/api/masterclass`, del módulo `masterclass`.
 *
 * Cada edición de la masterclass gratis por Zoom, con quién se apuntó y quién entró. De aquí
 * sale el LOTE: las tareas de llamar al día siguiente a quien asistió.
 */
export interface Masterclass {
  id: string;
  titulo: string;
  /** ISO con zona. */
  inicio: string;
  zoomUrl: string;
  cupo: number | null;
  /** `PROGRAMADA`, `HECHA` o `CANCELADA`. */
  estado: string;
  /** Cuándo se sacó el lote. `null` = todavía no. */
  loteHechoAt: string | null;
  inscritos: number;
  asistieron: number;
}

export interface DatosDeMasterclass {
  titulo: string;
  inicio: string;
  duracionMin?: number;
  zoomUrl?: string;
  cupo?: number | null;
}

/** Lo que al equipo se le puede olvidar, y que por eso se le pone delante. */
export interface MonitoreoDeMasterclass {
  /** Próximas sin enlace de Zoom: el agente no lo puede prometer. */
  sinEnlace: { id: string; titulo: string; inicio: string }[];
  /** Ya pasaron, hubo inscritos y nadie marcó quién entró. */
  sinAsistencia: { id: string; titulo: string; inicio: string; inscritos: number }[];
  /** Tienen asistentes y el lote sin sacar: esa gente no está siendo llamada. */
  loteSinSacar: { id: string; titulo: string; asistieron: number }[];
  /** El lote quedó a medias (el proceso se cayó): parejas que nadie va a llamar nunca. */
  loteIncompleto: { id: string; titulo: string; asistieron: number; creadas: number }[];
}

export const listarMasterclass = () => api.get<Masterclass[]>('/api/masterclass');
export const monitoreoDeMasterclass = () => api.get<MonitoreoDeMasterclass>('/api/masterclass/monitoreo');
export const crearMasterclass = (datos: DatosDeMasterclass) => api.post<{ id: string; creada: boolean }>('/api/masterclass', datos);

/** Convierte a los que asistieron en tareas para mañana. Apretarlo dos veces no crea nada dos veces. */
export const sacarElLote = (id: string) => api.post<{ creadas: number; yaEstaba: boolean }>(`/api/masterclass/${id}/lote`, {});
